export const SEVERITIES = ["low", "medium", "high", "critical"];

export const RISK_LEVELS = ["low", "medium", "high"];

export const NODE_TYPES = [
  "public_site",
  "admin_panel",
  "database",
  "office_laptops",
  "vendor_access",
  "cloud_storage",
];

export const CONTRACT_TYPES = ["log_analysis", "network_map", "phishing", "report_builder"];

export const TOOL_IDS = [
  "log_filter",
  "severity_highlighter",
  "false_positive_guard",
  "network_scanner",
  "access_matrix_viewer",
  "link_preview",
  "sender_check",
  "client_brief_analyzer",
  "priority_planner",
  "report_template",
];

export const SKILL_IDS = [
  "log_analysis",
  "network_security",
  "phishing",
  "web_security",
  "reporting",
  "automation",
];

export const ACHIEVEMENT_IDS = [
  "first_contract",
  "first_s_grade",
  "first_tool",
  "trusted_partner",
  "all_clients_unlocked",
  "level_5",
  "flawless_report",
];

export const RECOMMENDED_ACTION_CODES = [
  "enable_mfa",
  "review_admin_roles",
  "add_monitoring",
  "rotate_credentials",
  "restrict_vendor_access",
  "patch_public_site",
  "encrypt_backups",
  "segment_network",
  "disable_unused_accounts",
  "enforce_password_policy",
  "enable_audit_logging",
  "limit_data_export",
];

export const GRADES = ["S", "A", "B", "C", "Failed"];

export const EVENT_TYPES = ["daily_reward", "daily_challenge", "timed_event"];

export const RECURRENCES = ["daily", "weekly", "once"];
